import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { catchError, map, Observable, of } from 'rxjs';

// interfaces
import { IRega } from 'src/app/core/interfaces/ads/rega';

// enums
import { agencyType } from 'src/app/core/enums/user/agency-type';
import { RANDOM_VALUE } from 'src/app/core/enums/global/random-value';

// services
import { ApiResponseService } from 'src/app/core/services/handel-api-response/api-response.service';

export const regaDataResolver: ResolveFn<Observable<IRega> | null> = (route, state) => {

  // ES6 Destruction & Nested
  const { data: { ads } } = route;
  const { 
    adNumber,
    owner: {
      idNumber,
      licenseNumber,
      agencyType: userAgencyType, 
    }
  } = ads;

  /**
   * init
   */
  const _api = inject(ApiResponseService);

  /**
   * check if ad has adNumber & idNumber
   */
  if (adNumber && idNumber) {

    /**
     * 
     */
    const body = {
      adNumber: adNumber,
      idType: userAgencyType == agencyType.freeWork ? '1' : '2',
      idNumber: userAgencyType == agencyType.freeWork ? idNumber : licenseNumber,
    };

    /**
     * 
     */
    return _api.regaGetData(body, {
      // params: { [RANDOM_VALUE.loader]: true }
    }).pipe(
      catchError(err => of(null)),
      map(v => v?.advertisement),
    )

  }

  /**
   * default return
   */
  return null

};
